export var claimStyles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "24px",
    },
    card: {
        background: "#111820",
        borderRadius: "20px",
        border: "1px solid #1e2a38",
        padding: "40px",
        maxWidth: "480px",
        width: "100%",
        textAlign: "center",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4)",
    },
    title: {
        color: "#ffffff",
        fontSize: "28px",
        fontWeight: 600,
        marginBottom: "8px",
        fontFamily: "Inter, system-ui, sans-serif",
    },
    subtitle: {
        color: "#94a3b8",
        fontSize: "16px",
        marginBottom: "32px",
        fontFamily: "Inter, system-ui, sans-serif",
    },
    amountContainer: {
        background: "linear-gradient(135deg, rgba(249, 115, 22, 0.1) 0%, rgba(56, 189, 248, 0.1) 100%)",
        borderRadius: "16px",
        padding: "24px 32px",
        marginBottom: "24px",
        border: "1px solid rgba(249, 115, 22, 0.2)",
    },
    amountLabel: {
        color: "#94a3b8",
        fontSize: "14px",
        marginBottom: "8px",
        fontFamily: "Inter, system-ui, sans-serif",
    },
    amountValue: {
        color: "#ffffff",
        fontSize: "36px",
        fontWeight: 700,
        fontFamily: "Inter, system-ui, sans-serif",
    },
    tokenSymbol: {
        color: "#f97316",
        fontSize: "36px",
        fontWeight: 700,
        marginLeft: "8px",
    },
    button: {
        background: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
        color: "#ffffff",
        border: "none",
        borderRadius: "12px",
        padding: "16px 32px",
        fontSize: "18px",
        fontWeight: 600,
        cursor: "pointer",
        width: "100%",
        transition: "all 0.2s ease",
        fontFamily: "Inter, system-ui, sans-serif",
        position: "relative",
        overflow: "hidden",
    },
    buttonDisabled: {
        background: "linear-gradient(135deg, #374151 0%, #1f2937 100%)",
        cursor: "not-allowed",
        opacity: 0.7,
    },
    buttonHover: {
        transform: "translateY(-2px)",
        boxShadow: "0 8px 24px rgba(249, 115, 22, 0.4)",
    },
    connectButton: {
        background: "linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%)",
        color: "#ffffff",
        border: "none",
        borderRadius: "12px",
        padding: "16px 32px",
        fontSize: "18px",
        fontWeight: 600,
        cursor: "pointer",
        width: "100%",
        transition: "all 0.2s ease",
        fontFamily: "Inter, system-ui, sans-serif",
    },
    errorCard: {
        background: "rgba(239, 68, 68, 0.1)",
        border: "1px solid rgba(239, 68, 68, 0.3)",
        borderRadius: "12px",
        padding: "20px",
        marginBottom: "24px",
    },
    errorText: {
        color: "#ef4444",
        fontSize: "16px",
        fontFamily: "Inter, system-ui, sans-serif",
    },
    successCard: {
        background: "rgba(34, 197, 94, 0.1)",
        border: "1px solid rgba(34, 197, 94, 0.3)",
        borderRadius: "12px",
        padding: "20px",
        marginBottom: "24px",
    },
    successText: {
        color: "#22c55e",
        fontSize: "16px",
        fontFamily: "Inter, system-ui, sans-serif",
    },
    infoRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        background: "rgba(255, 255, 255, 0.03)",
        borderRadius: "8px",
        marginBottom: "8px",
    },
    infoLabel: {
        color: "#64748b",
        fontSize: "14px",
        fontFamily: "Inter, system-ui, sans-serif",
    },
    infoValue: {
        color: "#94a3b8",
        fontSize: "14px",
        fontFamily: "monospace",
        maxWidth: "200px",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
};
